import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M92.19 22.04c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M76.64 19.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path fill="#0597A3" d="M10.07 80.63a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      d="m26.17 96.17 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM113.83 43.7h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V46.7h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M23.44 30h69.11c1.35 0 2.44 1.07 2.44 2.39V83.6c0 1.32-1.09 2.39-2.44 2.39H23.44c-1.35 0-2.44-1.07-2.44-2.39V32.39c0-1.32 1.09-2.39 2.44-2.39"
    />
    <mask
      id="enrichedIcon-MessagesInverted_svg__a"
      width={74}
      height={56}
      x={21}
      y={30}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M23.44 30h69.11c1.35 0 2.44 1.07 2.44 2.39V83.6c0 1.32-1.09 2.39-2.44 2.39H23.44c-1.35 0-2.44-1.07-2.44-2.39V32.39c0-1.32 1.09-2.39 2.44-2.39"
      />
    </mask>
    <g mask="url(#enrichedIcon-MessagesInverted_svg__a)">
      <path fill="#0597A3" d="M22.04 86 58 45.55 93.96 86" />
      <path fill="#001A43" d="m21 30 34.79 36.1c1.3.99 3.12.99 4.42 0L95 30" />
    </g>
  </svg>
);
const SvgEnrichedIconMessagesInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconMessagesInverted);
export default Memo;
